const React = require('react');
const Button = require('components/button');
const Row = require('components/row');
const Col = require('components/col');
const FormInput = require('components/form-input');
const api = require('utils/api-controller');
const ctrl= require('controllers/cotacao-ctrl');
const FormComboBox = require('components/form-combo-box');
import Cotacao from 'views/cotacao/cotacao';
import Ofertar from 'views/ofertar/ofertar';
import router from 'utils/router';
import sysCtrl from 'controllers/sys-ctrl';

module.exports = React.createClass({

  mixins: [ ctrl.mixin, sysCtrl.mixin ],

  handleLogout(ev){
    api.clearProfile();
    ev.preventDefault();
  },


  handleChangePass(){
    window.location.hash = '#/mudarsenha';
  },

  render(){

    var content, clsCotacao = '', clsOfertar = '';

    if (router.getWithoutParams() == 'ofertar') {
      clsOfertar = 'active';
      content = <Ofertar />
    } else {
      clsCotacao = 'active';
      content = <Cotacao />
    }

    return (
      <div>
        <div>
          <Row>
            <Col size="sm-3 lg-2">
              <img className="logo" src="logotipo" alt=""/>
            </Col>
            <Col size="sm-9 lg-10">
                <Row>
                  <Col size="sm-12" className="text-center">
                    <h1>Olá, {api.profile.completeName}, bem vindo ao {sysCtrl.data.pageHeader}</h1>
                  </Col>
                </Row>
                <div className="row">
                  <div style={{marginTop:-10}} className="col col-sm-12 text-center" dangerouslySetInnerHTML={{__html: sysCtrl.data.msgTiraDuvidas}}></div>
                </div>
            </Col>
          </Row>
          <ul className="nav nav-tabs">
            <li className={clsCotacao}><a href="#/cotacao">Cotação em andamento</a></li>
            <li className={clsOfertar}><a href="#/ofertar">Ofereça seus produtos</a></li>
            <li className="pull-right">
              <div style={{marginTop: 10}}>
                <Button className="primary btn-sm" icon="refresh" onClick={ctrl.requestData}>Atualizar</Button>
                <Button className="danger btn-sm" onClick={this.handleLogout} style={{marginLeft: 5}}>Logout</Button>
                <Button className="success btn-sm" onClick={this.handleChangePass} style={{marginLeft: 5}}>Mudar Senha</Button>
              </div>
            </li>
          </ul>
          <div className="tab-content">
            <div className="tab-pane active">
              {content}
            </div>
          </div>

        </div>
      </div>
    )
  }

});


/** WEBPACK FOOTER **
 ** ./src/views/home/home.js
 **/